import React from 'react';
import PropTypes from 'prop-types';
import { AppLink } from '@easyllama/ui-components';
import { LlamaSettings } from '@easyllama/ui-components/icons';
import RowShell from '../atoms/RowShell';
import GroupHeading from '../atoms/GroupHeading';
import { SHORTCUT_HOTKEYS, SHORTCUT_ICONS } from '../constants';

function ShortcutList({ shortcuts, activeIndex, onHover, onRun, rowRefs }) {
  return (
    <section>
      <GroupHeading label="Pinned shortcuts" />
      <ul>
        {shortcuts.map((shortcut, index) => {
          const Icon = SHORTCUT_ICONS[shortcut.icon] || LlamaSettings;
          return (
            <RowShell
              key={shortcut.key}
              active={index === activeIndex}
              onHover={() => onHover(index)}
              innerRef={(node) => {
                rowRefs.current[index] = node;
              }}
            >
              <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-llama-purple-1 text-llama-purple-4">
                <Icon className="size-(--gs-medallion-icon)" />
              </span>
              <div className="min-w-0 flex-1">
                <AppLink
                  text={shortcut.title}
                  size="small"
                  className="!text-sm !font-semibold !text-llama-grey-7 !no-underline hover:!underline"
                  onClick={() => onRun(shortcut)}
                />
                {shortcut.subtitle && <p className="truncate text-[length:var(--gs-subtitle-font)] font-normal text-llama-grey-5">{shortcut.subtitle}</p>}
              </div>
              {index < SHORTCUT_HOTKEYS.length && (
                <kbd className="shrink-0 rounded-(--el-radius-rounded-xs) bg-llama-grey-9 px-1.5 py-0.5 font-mono text-[length:var(--gs-label-font)] font-medium text-llama-grey-5">
                  {SHORTCUT_HOTKEYS[index]}
                </kbd>
              )}
            </RowShell>
          );
        })}
      </ul>
    </section>
  );
}

ShortcutList.propTypes = {
  shortcuts: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onHover: PropTypes.func.isRequired,
  onRun: PropTypes.func.isRequired,
  rowRefs: PropTypes.object.isRequired,
};

export default ShortcutList;
